import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Activity from '@/views/Activity.vue'
import Admin from '@/views/Admin.vue'
import Checkin from '@/views/Checkin.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity
  },
  {
    path: '/activity1',
    name: 'Activity1',
    component: Activity
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/checkin',
    name: 'Checkin',
    component: Checkin
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
